import { isDevelopmentMode } from '@helpers/developmentMode';
import { isSSR } from '@helpers/ssr';
import { withMotion } from '@hoc/withMotion';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import { AnimatePresence } from 'framer-motion';
import Cookie from 'js-cookie';
import * as React from 'react';
import S from './FloatingCta.styles';
const FloatingCta = (props) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const setCookie = () => {
        // We just need to check for the existence of this, not anything //
        // within it as it is a necessary cookie which is enabled by default //
        if (Cookie.get('CookieConsent') !== undefined || isDevelopmentMode) {
            Cookie.set('SEEN_FLOATING_CTA', 'true');
        }
    };
    const setCookieAndRedirect = (e) => {
        e.preventDefault();
        setCookie();
        window.open(e.currentTarget.href, e.currentTarget.target);
    };
    React.useEffect(() => {
        if (!isSSR()) {
            const seenCtaCookie = Cookie.get('SEEN_FLOATING_CTA');
            setIsOpen(!seenCtaCookie && !props.showCollapsed);
        }
    }, [isSSR()]);
    return (React.createElement(S.Container, { isOpen: isOpen, onClick: () => {
            setCookie();
            setIsOpen((_isOpen) => !_isOpen);
        } },
        props.secondaryCta ? (React.createElement(S.ControlButton, null,
            React.createElement(SvgClose, { "data-icon": "close" }))) : null,
        React.createElement(AnimatePresence, null, isOpen && props.secondaryCta ? (React.createElement(S.AnimatedWrapper, { key: "secondary-cta-wrapper", "data-secondary": true },
            React.createElement(S.SecondaryCtaWrapper, null,
                props.secondaryCta.description ? (React.createElement(S.Description, null, props.secondaryCta.description)) : null,
                props.secondaryCta.url ? (React.createElement(LinkButton, { onClick: (e) => {
                        setCookieAndRedirect(e);
                    }, buttonType: "inverted", href: props.secondaryCta.url, target: props.secondaryCta.target, title: props.secondaryCta.text }, props.secondaryCta.text)) : null))) : null),
        React.createElement(S.MainCtaWrapper, null,
            React.createElement(AnimatePresence, null, isOpen && props.mainCta.description ? (React.createElement(S.AnimatedWrapper, { key: "main-cta-description" },
                React.createElement(S.Description, null, props.mainCta.description))) : null),
            props.secondaryCta ? (React.createElement(LinkButton, { onClick: (e) => {
                    setCookieAndRedirect(e);
                }, buttonType: "inverted", href: props.secondaryCta.url, target: props.secondaryCta.target, title: props.secondaryCta.text }, props.secondaryCta.text)) : null,
            props.mainCta.url ? (React.createElement(LinkButton, { onClick: (e) => {
                    setCookieAndRedirect(e);
                }, buttonType: "default", href: props.mainCta.url, target: props.mainCta.target, title: props.mainCta.text }, props.mainCta.text)) : null)));
};
export default withMotion(FloatingCta);
